import { render, staticRenderFns } from "./CtaRankList.vue?vue&type=template&id=3ba0d2e6"
import script from "./CtaRankList.vue?vue&type=script&lang=js"
export * from "./CtaRankList.vue?vue&type=script&lang=js"
import style0 from "./CtaRankList.vue?vue&type=style&index=0&id=3ba0d2e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports